export const COMPANY_NAME = "Magnetic Times LLC";
export const COMPANY_SHORT = "Magnetic Times LLC";
export const COMPANY_INITIALS = "MTL";
export const COMPANY_ADDRESS_FULL = "17400 Arrow Blvd APT 22, Fontana, California, US 92335-3981";
export const COMPANY_LOCATION = "Fontana, CA";
export const COMPANY_REGION = "Fontana, CA";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=17400%20Arrow%20Blvd%20APT%2022%2C%20Fontana%2C%20California%2C%20US%2092335-3981";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Magnetic Times LLC" },
  { "label": "Location", "value": "Fontana, CA" },
  { "label": "State", "value": "California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Magnetic Times LLC" },
  { "label": "City / State", "value": "Fontana, CA" },
  { "label": "Address", "value": "17400 Arrow Blvd APT 22, Fontana, California, US 92335-3981" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Organization", "body": "A public profile for Magnetic Times LLC." },
  { "icon": "✦", "title": "Location", "body": "Based in Fontana, California." },
  { "icon": "✿", "title": "Public details", "body": "The profile presents the organization name and address provided." },
];
